import { render, staticRenderFns } from "./ModalPendingAccount.vue?vue&type=template&id=62b3286e"
import script from "./ModalPendingAccount.vue?vue&type=script&lang=js"
export * from "./ModalPendingAccount.vue?vue&type=script&lang=js"
import style0 from "./ModalPendingAccount.vue?vue&type=style&index=0&id=62b3286e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ModalPendingAccount.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports